import React from 'react';
import assign from 'object-assign';
import MenuItem from 'material-ui/MenuItem';

import Form from '../Common/Form.react';
import TextField from '../Common/TextField';
import SelectField from '../Common/SelectField';
import DatePicker from '../Common/DatePicker';
import TimePicker from '../Common/TimePicker';
import { FormsyCheckbox as Checkbox } from 'formsy-material-ui';
import { Card, CardText } from 'material-ui/Card';
import { createPills } from '../Common/Pill';
import { formatName } from '../../utils/StringUtils';

import EventActions from '../../actions/EventActionCreator';
import EventStore from '../../stores/EventStore';

import ModuleStore from '../../stores/ModuleStore';
import ModuleTrainerStore from '../../stores/ModuleTrainerStore';
import ModuleActions from '../../actions/ModuleActionCreator';

import VenueActions from '../../actions/VenueActionCreator';
import VenueStore from '../../stores/VenueStore';

import PeriodicTypeActions from '../../actions/PeriodicTypeActionCreator';
import PeriodicTypeStore from '../../stores/PeriodicTypeStore';
import LocationStore from '../../stores/LocationStore';
import LocationActions from '../../actions/LocationActionCreator';
import EventNotificationSettings from '../Event/EventNotificationSettings';
import EventNotificationStore from '../../stores/EventNotificationStore';

const url = '/dashboard/modules';

const ModuleEventForm = React.createClass({

    getInitialState: function () {
        const eventId = Number(this.props.routeParams.eventId) || null;
        return {
            eventId,
            isEdit: (this.props.routeParams.eventId !== undefined && !!this.props.routeParams.eventId.match(/\d+/)),
            redirectTo: '',
            setDefaultDates: false,

            details: {
                id: '',
                name: '',
                identificationNumber: '',
                description: '',
                capacity: '0',
                minCapacity: '0',
                price: '',
                displayGuests: 0,
                displayQR: 0,
                displayCapacity: 0,
                displayRemaining: 0,
                visibility: 'private',
                venue: 'N/A',
                venueId: 0,
                location: 'N/A',
                locationId: 0,
                type: 'event',
                status: 'active',
                theme: 'default',
                timeRegistration: null,
                timeStart: null,
                timeEnd: null,
                dateStart: null,
                dateEnd: null,
                attendanceLocked: null,
                trainers: [],

                periodic: false,
                periodTypeId: 0,

                periodicEndsOn: null,
                periodicEndsAfterCount: 1,
                endType: 'never'
            },
            notifications: [],
            module: {
                id: this.props.routeParams.id,
                name: '',
                description: '',
                visibility: '',
                theme: '',
                eventTemplateId: null
            },
            venueOptions: ['N/A'],
            locationOptions: [],
            dropdowns: {
                statusOptions: [],
                typeOptions: [],
                themeOptions: [],
                visibilityOptions: ['private', 'public'],
                displayGuestsOptions: [
                    {id: 0, name: 'no'},
                    {id: 1, name: 'yes'}
                ],
                periodType: [],
                endTypeOptions: [
                    {id: 0, value: 'never', name: 'Always'},
                    {id: 1, value: 'afterRepeat', name: 'For'},
                    {id: 2, value: 'onDate', name: 'Until'}
                ]
            },
            waitingList: 0,
            trainerOptions: []
        }
    },

    componentDidMount: function() {
        this.listeners = [
            ModuleStore.addListener(this.onModuleChange),
            EventStore.addListener(this._onChange),
            VenueStore.addListener(this.onVenueChange),
            LocationStore.addListener(this.onLocationChange),
            EventNotificationStore.addListener(this.onNotificationsChange),
            PeriodicTypeStore.addListener(this._onChange),
            ModuleTrainerStore.addListener(this.onTrainersChange)
        ];
        ModuleActions.getById(this.props.routeParams.id);
        ModuleActions.getTrainers(this.props.routeParams.id);

        EventActions.getStatusOptions();
        EventActions.getTypeOptions();

        if (this.state.isEdit) {
            EventActions.getById(this.state.eventId);
            EventActions.listNotifications(this.state.eventId);
        }


        VenueActions.getAll();
        PeriodicTypeActions.getAll();

    },

    componentWillUnmount: function() {
        this.listeners.forEach(listener => listener.remove());
    },


    render: function () {

        const redirectTo = (this.state.isEdit ? `/dashboard/module/${this.state.details.id}/events` : url);

        return(
            <Form
                title={this.state.module.name}
                onSave={this._onSave}
                onCancel={this._onCancel}
                redirectTo={redirectTo}
            >
                <Card className="cent-card">
                    <CardText>
                        <div className='cent-flex-row'>
                            <div className='cent-col-1'>
                                <TextField
                                    name="identificationNumber"
                                    hintText="Identification Number"
                                    validations="maxLength:12"
                                    validationError="Please use no more than 12 characters"
                                    value={this.state.details.identificationNumber}
                                    floatingLabelText="Identification Number"
                                />
                            </div>

                                {this.state.details.dateStart && this.state.details.type !== 'template' &&
                                <div className='cent-col-2'>
                                    <DatePicker
                                        name='dateStart'
                                        value={this.state.details.dateStart}
                                        floatingLabelText="Start date"
                                        onChange={this._onChangeTimeStart}
                                        required
                                    />
                                </div>
                                }
                                {this.state.details.timeStart &&
                                <div className='cent-col-2'>
                                    <TimePicker
                                        name='timeStart'
                                        value={this.state.details.timeStart}
                                        floatingLabelText="Start time"
                                        required
                                    />
                                </div>
                                }
                                {this.state.details.dateEnd && this.state.details.type !== 'template' &&
                                <div className='cent-col-2'>
                                    <DatePicker
                                    name='dateEnd'
                                    value={this.state.details.dateEnd}
                                    floatingLabelText="End date"
                                    required
                                    />
                                </div>
                                }
                            {this.state.details.timeEnd &&
                            <div className='cent-col-2'>
                                <TimePicker
                                    name='timeEnd'
                                    value={this.state.details.timeEnd}
                                    floatingLabelText="End time"
                                    required
                                />
                            </div>
                            }
                            {this.state.details.timeRegistration &&
                            <div className='cent-col-2'>
                                <TimePicker
                                    name='timeRegistration'
                                    value={this.state.details.timeRegistration}
                                    floatingLabelText="Registration time"
                                />
                            </div>
                            }
                            <div className='cent-col-1'>
                                <SelectField
                                    name="periodTypeId"
                                    value={this.state.details.periodTypeId}
                                    disabled={this._periodTypeIsEditable()}
                                    hintText="Repeat"
                                    floatingLabelText="Repeat"
                                    onChange={this._onChangePeriodTypeId}
                                    required>
                                    <MenuItem key="root" value={0} primaryText="No" />
                                    {this.state.dropdowns.periodType.map(function(periodType) {
                                        return (
                                            <MenuItem
                                                key={periodType.id}
                                                value={periodType.id}
                                                primaryText={periodType.name}
                                            />
                                        )
                                    })}
                                </SelectField>

                                {this.state.details.periodic &&
                                <SelectField
                                    name="endType"
                                    value={this.state.details.endType}
                                    floatingLabelText="Repeating"
                                    required
                                    onChange={this._onChangeEndType}>
                                    {this.state.dropdowns.endTypeOptions.map(function (endType) {
                                        return (
                                            <MenuItem
                                                key={endType.id}
                                                value={endType.value}
                                                primaryText={endType.name}
                                            />
                                        )
                                    })}
                                </SelectField>
                                }
                                {this.state.endsAfterCountEnable &&
                                <TextField
                                    name='periodicEndsAfterCount'
                                    value={this.state.details.periodicEndsAfterCount}
                                    validations="isNumeric"
                                    validationError="Please use only numbers"
                                    hintText="After occurrences"
                                    floatingLabelText="After occurrences"
                                    required/>
                                }
                                {this.state.endsOnEnable &&
                                <DatePicker
                                    name='periodicEndsOn'
                                    value={this.state.details.periodicEndsOn==null ? this._shiftDate(31) : new Date(this.state.details.periodicEndsOn)}
                                    floatingLabelText="Ends on"
                                    required/>
                                }
                            </div>
                            <h2>Location</h2>
                            <p className="subHeading">Venue, location and capacity settings</p>
                            <div className='cent-col-2'>
                                <SelectField
                                    name="venueId"
                                    value={this.state.details.venueId}
                                    floatingLabelText="Venue"
                                    onChange={this.onUpdateVenue}
                                    required
                                >
                                    <MenuItem key="none" value={0} primaryText="N/A"/>
                                    {this.state.venueOptions.map((venue) => {
                                        const primaryText = `${venue.name} ${(!!venue.capacity ? ` [${venue.capacity}]` : ' ')}`;
                                        return (
                                            <MenuItem
                                                key={venue.id}
                                                value={venue.id}
                                                primaryText={primaryText}
                                                disabled = {(venue.status !== 'available')}
                                            />
                                        )
                                    })}
                                </SelectField>
                            </div>
                            <div className='cent-col-2'>
                                <SelectField
                                    key={`locationForVenue${this.state.details.venueId}`}
                                    name="locationId"
                                    value={this.state.details.locationId}
                                    floatingLabelText="Location"
                                >
                                    <MenuItem key="none" value={0} primaryText="N/A"/>
                                    {this.state.locationOptions}
                                </SelectField>
                            </div>
                            <div className='cent-col-2'>
                                <TextField
                                    name='capacity'
                                    value={this.state.details.capacity}
                                    validations="isNumeric"
                                    validationError="Please use only numbers"
                                    hintText="Max. Capacity"
                                    floatingLabelText="Max. Capacity"
                                />
                            </div>
                            <div className='cent-col-2'>
                                <TextField
                                    name='minCapacity'
                                    value={this.state.details.minCapacity}
                                    validations="isNumeric"
                                    validationError="Please use only numbers"
                                    hintText="Min. Capacity"
                                    floatingLabelText="Min. Capacity"
                                />
                            </div>
                            {!this.state.isEdit && (
                                <div>
                                    <h2>Trainers</h2>
                                    <p className="subHeading">Select the trainers for this event</p>
                                </div>
                            )}
                            {!this.state.isEdit && (
                                <div className="cent-col-1">
                                    <SelectField
                                        name="trainers"
                                        hintText="Trainers"
                                        floatingLabelText="Trainers"
                                        onChange={this.onSelectTrainer}
                                    >
                                        <MenuItem key="none" value="" primaryText="" />
                                        {this.state.trainerOptions.map((trainer) => (
                                            <MenuItem key={trainer.userId} value={trainer.userId} primaryText={formatName(trainer)}/>
                                        ))}

                                    </SelectField>
                                    <div className="cent-form-chips">{this.createTrainerPills()}</div>
                                </div>
                            )}
                            <h2>Display</h2>
                            <p className="subHeading">Elements selected here will be viewable to the end user</p>
                            <div className='cent-col-1'>
                                <div className='cent-checkbox-wrapper'>
                                    <Checkbox
                                        name="displayCapacity"
                                        value={this.state.details.displayCapacity}
                                        label="Show event capacity"
                                    />
                                </div>
                            </div>
                            <div className='cent-col-1'>
                                <div className='cent-checkbox-wrapper'>
                                    <Checkbox
                                        name="displayGuests"
                                        value={this.state.details.displayGuests}
                                        label="Show the guest list"
                                    />
                                </div>
                            </div>
                            <div className='cent-col-1'>
                                <div className='cent-checkbox-wrapper'>
                                    <Checkbox
                                        name="displayRemaining"
                                        value={this.state.details.displayRemaining}
                                        label="Show remaining places"
                                    />
                                </div>
                            </div>
                            <div className='cent-col-1'>
                                <div className='cent-checkbox-wrapper'>
                                    <Checkbox
                                        name="displayQR"
                                        value={this.state.details.displayQR}
                                        label="Show QR code"
                                    />
                                </div>
                            </div>
                            <h2>Accessibility</h2>
                            <p className="subHeading">Configure how users will access this event</p>
                            <div className="cent-col-2">
                                <SelectField
                                    name="visibility"
                                    value={this.state.details.visibility}
                                    floatingLabelText="Visibility"
                                >
                                    {this.state.dropdowns.visibilityOptions.map((visibility) => (<MenuItem key={visibility} value={visibility} primaryText={visibility}/>))}
                                </SelectField>
                            </div>
                            <div className="cent-col-2">
                                <SelectField
                                    name="status"
                                    value={this.state.details.status}
                                    hintText="status"
                                    floatingLabelText="status"
                                    required
                                >
                                    {this.state.dropdowns.statusOptions.map(function(status) {
                                        return (
                                            <MenuItem
                                                key={status.id}
                                                value={status.name}
                                                primaryText={status.name}
                                            />
                                        )
                                    })}
                                </SelectField>
                            </div>
                            <h2>Waiting List</h2>
                            <p className="subHeading">Configure event waiting list</p>
                            <div className='cent-col-1'>
                                <div className='cent-checkbox-wrapper'>
                                    <Checkbox
                                        name="waitingList"
                                        value={this.state.waitingList}
                                        label="Enabled"
                                        onChange={() => this.setState({waitingList: !this.state.waitingList})}
                                    />
                                </div>
                            </div>
                            {this.state.waitingList && (
                                <div className='cent-col-2'>
                                    <TextField
                                        name='waitingListCapacity'
                                        value={this.state.details.waitingListCapacity === -1 ? '' : this.state.details.waitingListCapacity}
                                        validations="isNumeric"
                                        validationError="Please use only numbers"
                                        hintText="Limit"
                                        floatingLabelText="Limit"
                                    />
                                    <div className='cent-checkbox-wrapper'>
                                        <Checkbox
                                            name="attendanceLocked"
                                            value={this.state.details.attendanceLocked}
                                            label="Add new bookings to waiting list"
                                        />
                                    </div>
                                </div>
                            )}
                        </div>
                        <div className='cent-col-1'>
                            <h2>Notifications</h2>
                            <p className="subHeading">Configure event notifications</p>
                            <EventNotificationSettings
                                notifications={this.state.notifications}
                            />
                        </div>
                    </CardText>
                </Card>
            </Form>
      );
    },

    _shiftDate: function(days){
        let currentDate = new Date();
        currentDate.setDate(currentDate.getDate() + days);
        return currentDate;
    },

    _periodTypeIsEditable: function() {
        let result = false;
        if (this.state.details.timeEnd !== null && this.state.isEdit) {
            const currentDate = new Date();
            const endDate = new Date(this.state.details.timeEnd);
            result = (endDate < currentDate);
        }
        return result;
    },

    _setPeriodTypeDropdown: function(periodTypes, timeStart) {
        if (periodTypes.length === 0) { return []; } //guard

        if (!timeStart || isNaN(timeStart.getTime())) {
            timeStart = new Date();
        }

        const days = ["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"];
        const weeks = ["1st", "2nd", "3rd", "4th", "last"];
        const months = ["January","February","March","April","May","June","July","August","September","October","November","December"];

        const startDay = timeStart.getDay();
        const startDate = timeStart.getDate();
        const startMonth = timeStart.getMonth();

        let prevWeek = new Date();
        prevWeek.setDate(startDate - 7);
        let currentWeek = startDate;
        let week = 0;
        let isCurrentMonth = true;
        while (isCurrentMonth) {
            if (prevWeek.getDate() > currentWeek)
                isCurrentMonth = false;
            else {
                currentWeek = prevWeek.getDate();
                prevWeek.setDate(prevWeek.getDate() - 7);
                week++;
            }
        }

        periodTypes.forEach(({id}, i) => {
            switch (id) {
                case 1:
                    periodTypes[i].name = "Daily";
                    break;
                case 2:
                    periodTypes[i].name = "Weekly";
                    break;
                case 6:
                    periodTypes[i].name = `Monthly on the ${startDate}`;
                    break;
                case 7:
                    periodTypes[i].name = `Monthly on the ${weeks[week]} ${days[startDay]}`;
                    break;
                case 8:
                    periodTypes[i].name = `Annually on ${startDate} ${months[startMonth]}`;
                    break;
            }
        });

        return periodTypes;
    },

    _onChangeTimeStart: function(event, value) {
        const periodType = this._setPeriodTypeDropdown(this.state.dropdowns.periodType, value);
        const dropdowns = assign({}, this.state.dropdowns, {periodType});
        this.setState({ dropdowns });
    },

    _onChangePeriodTypeId: function(event, value) {
        let details = assign({}, this.state.details, { periodic: (value !== 0), periodTypeId: value });
        const endsOnEnable = (details.periodic && details.endType === 'onDate');
        const endsAfterCountEnable = (details.periodic && details.endType === 'afterRepeat');

        this.setState({ details, endsOnEnable, endsAfterCountEnable });
    },

    _onChangeEndType: function(event,value) {
        let details = assign({}, this.state.details, { endType: value });
        const endsOnEnable = (details.periodic && value ==='onDate');
        const endsAfterCountEnable = (details.periodic && value ==='afterRepeat' );
        this.setState({ details, endsOnEnable, endsAfterCountEnable });
    },

    onUpdateVenue: function(event, venueId) {
        if (venueId !== this.state.details.venueId) {
            LocationActions.getAllByVenue(venueId);
            const details = assign({}, this.state.details, { venueId, locationId: 0 });
            this.setState({ details });
        }
    },

    _onSave: function(data) {
        // let's combine date and time values:
        if (this.state.details.type !== 'template') {
            data.timeStart.setFullYear(data.dateStart.getFullYear(), data.dateStart.getMonth() , data.dateStart.getDate());
            data.timeRegistration.setFullYear(data.dateStart.getFullYear(), data.dateStart.getMonth(), data.dateStart.getDate());
            data.timeEnd.setFullYear(data.dateEnd.getFullYear(), data.dateEnd.getMonth(), data.dateEnd.getDate());
        }

        data.periodic = this.state.details.periodic;

        if (data.periodic) {
            data.periodicRepeatCount = 1;

            if (data.periodTypeId === 2) {
                const repeatDay = data.timeStart.getDay();

                data.periodicRepeatOnSunday    = (repeatDay === 0);
                data.periodicRepeatOnMonday    = (repeatDay === 1);
                data.periodicRepeatOnTuesday   = (repeatDay === 2);
                data.periodicRepeatOnWednesday = (repeatDay === 3);
                data.periodicRepeatOnThursday  = (repeatDay === 4);
                data.periodicRepeatOnFriday    = (repeatDay === 5);
                data.periodicRepeatOnSaturday  = (repeatDay === 6);
            }
        }

        data.timeStart = data.timeStart.toString().replace(/\s\([^)]+\)/, '');
        data.timeEnd = data.timeEnd.toString().replace(/\s\([^)]+\)/, '');
        data.timeRegistration = data.timeRegistration.toString().replace(/\s\([^)]+\)/, '');

        data.type = this.state.details.type;

        if (!data.waitingList) {
            data.waitingListCapacity = 0;
        } else if (data.waitingListCapacity === ''){
            data.waitingListCapacity = -1;
        }

        if (this.state.isEdit) {
            return ModuleActions.updateEvent(this.props.routeParams.eventId, data);
        } else {
            if (!!this.state.details.trainers) {
                data.trainers = this.state.details.trainers;
            }
            return ModuleActions.addEvent(this.props.routeParams.id, data);
        }
    },

    onModuleChange: function() {
        const module = ModuleStore.getById(this.props.routeParams.id);

        if (module !== undefined) {
            this.setState({module});
        }
        if (!!this.state.module.eventTemplateId) {
            EventActions.getById(this.state.module.eventTemplateId);
        } else if (!this.state.isEdit){
            const details = {
                dateStart: new Date(),
                dateEnd: new Date(),
                timeStart: new Date(),
                timeEnd: new Date(),
                timeRegistration: new Date()
            };
            this.setState({setDefaultDates: true, details: assign({}, this.state.details, details)});
        }
    },

    _onChange: function() {

        let details = assign({}, this.state.details);

        if (this.state.isEdit) {
            details.timeStart = new Date(details.timeStart);
            details.timeEnd = new Date(details.timeEnd);
            details.dateStart = details.timeStart;
            details.dateEnd = details.timeEnd;

            let event = EventStore.getById(this.state.eventId);
            if (event !== undefined) {
                details = assign({}, details, event);
            }
        } else if (!!this.state.module.eventTemplateId){
            const template = EventStore.getById(this.state.module.eventTemplateId);
            if (template !== undefined) {
                details = assign(details, template);
                details.dateStart = new Date();
                details.dateEnd = new Date();
                details.timeStart = new Date(template.timeStart);
                details.timeEnd = new Date(template.timeEnd);
                details.timeRegistration = new Date(template.timeRegistration);
                details.type = 'event';
            }
        }

        details.venueId = Number(details.venueId) || 0;
        details.locationId = Number(details.locationId) || 0;

        let dropdowns = assign({}, this.state.dropdowns, {
            statusOptions:  EventStore.getStatusOptions(),
            typeOptions:    EventStore.getTypeOptions()
        });

        let periodType = PeriodicTypeStore.getAll();
        let timeStart;
        if (this.state.isEdit) {
            timeStart = new Date(details.timeStart);
        } else if (this.state.module.eventTemplateId) {
            timeStart = new Date();
        } else {
            timeStart = details.timeStart;
        }
        dropdowns.periodType = this._setPeriodTypeDropdown(periodType, timeStart);

        this.setState({details,dropdowns, waitingList: details.waitingListCapacity !== 0});
    },

    onNotificationsChange: function() {
        const notifications = EventNotificationStore.getByEvent(this.state.eventId);
        if (!!notifications) {
            this.setState({notifications});
        }
    },

    onVenueChange: function() {
          const venues = VenueStore.getAll();
          if (venues !== undefined) {
              this.setState({ venueOptions: venues });
          }
    },

    onLocationChange: function() {
        const locations = LocationStore.getAllByVenue(this.state.details.venueId);
        if (locations !== undefined) {
            this.setState({locationOptions: locations.map( ({id, name}) => <MenuItem key={id} value={id} primaryText={name} />)});
        }
    },

    onTrainersChange: function () {
        const trainerOptions = ModuleTrainerStore.getByModule(this.props.routeParams.id);
        if (!!trainerOptions) {
            this.setState({trainerOptions})
        }
    },

    createTrainerPills: function () {
        const deleteAction = (trainer) => this.setState({details: {...this.state.details, trainers: this.state.details.trainers.filter((trainerId) => trainerId !== trainer)}});
        return createPills(this.state.details.trainers, this.state.trainerOptions, deleteAction, { key: 'userId' });
    },

    onSelectTrainer: function (e, trainerId) {
        if (!trainerId || this.state.details.trainers.includes(trainerId)) { return null; }
        this.setState({details: {...this.state.details, trainers: [...this.state.details.trainers, trainerId]}})
    }
});

export default ModuleEventForm;
